import Navbar from "../components/Navbar";

function HowToPlay() {
  return (
    <div style={{ minHeight: "100vh", paddingBottom: "3rem" }}>
      <Navbar />
      <div className="app-container" style={{ maxWidth: '800px', margin: '0 auto', marginTop: '2rem' }}>
        <div className="glass-morphism animate-fade-in how-to-card">
           <h1 className="gradient-text how-to-title">HOW TO PLAY IPL ARENA</h1>
           <p className="how-to-subtitle">
             Welcome to IPL Arena! This is a fun and easy game where you can guess IPL match winners and earn points.
           </p>

           <div className="how-to-section">
             <h2 className="how-to-heading">🏏 What is IPL Arena?</h2>
             <p className="how-to-text">It is a free game for cricket fans! You just have to pick which team you think will win today's IPL match. If your team wins, you get points!</p>
           </div>
           
           <div className="how-to-section">
             <h2 className="how-to-heading">📊 How the Points Work</h2>
             <p className="how-to-text">Different teams give you different points:<br/><br/>
             • <b>Safe Pick:</b> Picking a very strong team gives you normal points.<br/>
             • <b>Risky Pick:</b> Picking a weak team gives you a HUGE amount of points if they win!<br/><br/>
             Your points are added automatically as soon as the real match is over.</p>
           </div>

           <div className="how-to-section">
             <h2 className="how-to-heading">🔥 Wild Guess Bonus</h2>
             <p className="how-to-text">Do you like taking big risks? If you pick the weakest team in the tournament and they actually win, you hit the massive <strong>75 Points Jackpot</strong>! Big risks mean big rewards.</p>
           </div>
           
           <div className="how-to-section">
             <h2 className="how-to-heading">🏆 The Leaderboard</h2>
             <p className="how-to-text">Every time you guess right, your total points go up. You can check the "Rankings" page to see who has the most points in the world. Want to be Number 1? Keep guessing the right winners!</p>
           </div>
           
           <div className="how-to-section">
             <h2 className="how-to-heading">📅 Daily Matches</h2>
             <p className="how-to-text">New matches appear every day. Just remember to pick your winning team before the match is over! Once the admin updates the real match result, your points are automatically added to your profile.</p>
           </div>
        </div>
      </div>
    </div>
  );
}

export default HowToPlay;
